import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { supabase } from '../supabase/client'
import './EditProfilePage.css'

const EditProfilePage = () => {
  const { profileId } = useParams()
  const navigate = useNavigate()

  const [profileData, setProfileData] = useState({
    firstName: '',
    lastName: '',
    position: '',
    company: '',
  })

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [isSaving, setIsSaving] = useState(false)

  // Загрузка данных профиля
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        setLoading(true)
        const { data, error } = await supabase
          .from('ipr_profiles')
          .select('firstName, lastName, position, company')
          .eq('userId', profileId)
          .single()

        if (error) {
          console.error('Error fetching profile:', error)
          throw error
        }

        setProfileData(data)
      } catch (err) {
        console.error('Ошибка при загрузке профиля:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    if (profileId) {
      fetchProfileData()
    } else {
      setLoading(false)
    }
  }, [profileId])

  // Обработчик изменения полей персональной информации
  const handlePersonalInfoChange = (e) => {
    const { name, value } = e.target
    setProfileData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  // Обработчик сохранения изменений профиля
  const handleSaveProfile = async (e) => {
    e.preventDefault()

    try {
      setIsSaving(true)

      const { error } = await supabase
        .from('ipr_profiles')
        .update({
          ...profileData,
        })
        .eq('userId', profileId)

      if (error) {
        console.error('Error saving profile:', error)
        throw error
      }

      // После успешного сохранения перенаправляем на страницу профиля
      navigate(`/profile/${profileId}`)
    } catch (err) {
      console.error('Ошибка при сохранении профиля:', err)
      setError(err.message)
    } finally {
      setIsSaving(false)
    }
  }

  // Обработчик для возврата к дашборду
  const handleCancel = () => {
    navigate('/dashboard')
  }

  if (loading) {
    return (
      <div className="edit-profile-container">
        <div className="edit-profile-loading">
          <div className="loader"></div>
          <p>Загрузка данных профиля...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="edit-profile-container">
      <div className="edit-profile-header">
        <h1>Редактирование профиля</h1>
      </div>

      {error && (
        <div className="edit-profile-error">
          <p>{error}</p>
        </div>
      )}

      <form onSubmit={handleSaveProfile}>
        <div className="form-section">
          <h2>Персональная информация</h2>

          <div className="form-group">
            <label htmlFor="firstName">Имя:</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={profileData.firstName}
              onChange={handlePersonalInfoChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="lastName">Фамилия:</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={profileData.lastName}
              onChange={handlePersonalInfoChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="position">Должность:</label>
            <input
              type="text"
              id="position"
              name="position"
              value={profileData.position}
              onChange={handlePersonalInfoChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="company">Компания:</label>
            <input
              type="text"
              id="company"
              name="company"
              value={profileData.company}
              onChange={handlePersonalInfoChange}
            />
          </div>
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="btn-secondary"
            onClick={handleCancel}
            disabled={isSaving}
          >
            Отмена
          </button>
          <button type="submit" className="btn-primary" disabled={isSaving}>
            {isSaving ? 'Сохранение...' : 'Сохранить изменения'}
          </button>
        </div>
      </form>
    </div>
  )
}

export default EditProfilePage
